export default function WhiteCardContainer({ children }) {
    return <div className="shadow sm:rounded-md sm:overflow-hidden">{children}</div>;
}
